import React, { useEffect, useState } from "react";
import { FaCheck, FaPlus } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
import { LuView } from "react-icons/lu";
import { HiOutlineRefresh } from "react-icons/hi";
import { FaSave, FaSearch } from "react-icons/fa";
import { IoPrint } from "react-icons/io5";
import { RiCloseLargeFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import A1 from '../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select';

const ItemMaster = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ itemCd: '', itemDesc: '', hsnCode: '', taxRate: '', closeFlag: '', itc: '', image: '', itemUOM: '', itemLocation: '', origin: '', cth: '', minQty: '', Main_Grp: '', Main_Grp_Desc: '', grade: '', validity: '', maxQty: '', Sub_Grp: '', Sub_Grp_Desc: '', abc: '', ved: '', reOrderQty: '', make: '', prodCode: '', department: '', department1: '', blockUnblock: '', accountCode: '', accountCodee: '' });
    const [showForm, setShowForm] = useState(false);
    const [items, setItems] = useState([]);

    const user = JSON.parse(sessionStorage.getItem('user'));
    const user_Id = user ? user.id : null;
    const userName = user ? user.Emp_Name : 'Guest';
    useEffect(() => {
        fetchItems();
    }, [user_Id]);

    const fetchItems = async () => {
        try {
            const response = await fetch('https://erpapi.emedha.in/pages/api/api/itemsmasterform');
            if (!response.ok) {
                throw new Error('Failed to fetch items');
            }
            const data = await response.json();
            setItems(data);
        } catch (err) {
            console.error('Error fetching items:', err.message);
        }
    };

    const [mainGroups, setMainGroups] = useState([]);
    const [subGroups, setSubGroups] = useState([]);
    const [filteredSubGroups, setFilteredSubGroups] = useState([]);


    useEffect(() => {
        axios.get('https://erpapi.emedha.in/pages/api/api/maingrp')
            .then((response) => {
                setMainGroups(response.data);
            })
            .catch((error) => {
                console.error('Error fetching main groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/subgrp')
            .then((response) => {
                setSubGroups(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
    }, []);


    useEffect(() => {
        if (formData.Main_Grp) {
            const filteredSub = subGroups.filter(group => group.Main_Grp === parseInt(formData.Main_Grp));
            console.log(filteredSub);
            setFilteredSubGroups(filteredSub);
        }
    }, [formData.Main_Grp, subGroups]);


    const selectedDescription = mainGroups.find(group => group.Main_Grp === parseInt(formData.Main_Grp))?.Main_Grp_Desc || '';
    const selectedSubDescription = subGroups.find(group => group.Sub_Grp === parseInt(formData.Sub_Grp))?.Sub_Grp_Desc || '';

    const [searchTerm, setSearchTerm] = useState("");
    const [filteredItems, setFilteredItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const fetchItemss = async (searchTerm = '') => {
        try {
            const response = await fetch(`https://erpapi.emedha.in/pages/api/api/itemsmasterform?searchTerm=${searchTerm}`);
            if (!response.ok) {
                throw new Error('Failed to fetch items');
            }
            const data = await response.json();
            setFilteredItems(data);
        } catch (err) {
            console.error('Error fetching items:', err.message);
        }
    };
    console.log(selectedItem)
    useEffect(() => {
        if (searchTerm) {
            fetchItemss(searchTerm);
        } else {
            setFilteredItems([]);
        }
    }, [searchTerm]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    // const handleSelectChangee = (selectedOption) => {
    //     // Simulate the event for handleInputChange
    //     handleInputChange({
    //         target: {
    //             name: 'Sub_Grp',
    //             value: selectedOption ? selectedOption.value : '', // If no selection, set value to empty
    //         }
    //     });
    // };
    // const handleSelectChangemg = (selectedOption) => {
    //     // Simulate the event for handleInputChange
    //     handleInputChange({
    //         target: {
    //             name: 'Main_Grp',
    //             value: selectedOption ? selectedOption.value : '', // If no selection, set value to empty
    //         }
    //     });
    // };
    const handleSelectChangemg = (selectedOption) => {
        setFormData({
            ...formData,
            Main_Grp: selectedOption.value,
            Sub_Grp: '', // Reset Sub_Grp when Main_Grp changes
        });
    };

    useEffect(() => {
        console.log("Filtered Sub Groups:", filteredSubGroups);
        console.log("Form Data Sub_Grp:", formData.Sub_Grp);
    }, [filteredSubGroups, formData.Sub_Grp]);


    const handleSelectChangee = (selectedOption) => {
        console.log('Selected Option:', selectedOption);
        setFormData({
            ...formData,
            Sub_Grp: selectedOption.value,
        });
    };

    const selectedOption = filteredSubGroups.find(option => option.Sub_Grp === formData.Sub_Grp);

    // const options = filteredSubGroups.map(group => ({
    //     value: group.Sub_Grp,
    //     label: `${group.Sub_Grp} - ${group.Sub_Grp_Desc}`
    // }));
    const options = filteredSubGroups.map(group => ({
        value: group.Sub_Grp,
        label: `${group.Sub_Grp} - ${group.Sub_Grp_Desc}` // Using .trim() to remove any extra spaces or newlines
    }));

    const optionss = mainGroups.map(group => ({
        value: group.Main_Grp,
        label: `${group.Main_Grp} - ${group.Main_Grp_Desc}`
    }));

    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);



    const handleSaveItem = async () => {
        // if (!formData.itemUOM || !formData.origin || !formData.itemDesc || !formData.hsnCode || !formData.taxRate || !formData.itc  
        //        || !formData.prodCode || !formData.minQty || !formData.Main_Grp || !formData.Sub_Grp || !formData.minQty ) {
        //     alert('ItemDesc, and HSNCode ,origin , ITC, ProdCode are required!');
        //     return;
        // }

        let missingFields = [];

        if (!formData.itemUOM) missingFields.push('ItemUOM');
        // if (!formData.origin) missingFields.push('Origin');
        if (!formData.itemDesc) missingFields.push('ItemDesc');
        if (!formData.hsnCode) missingFields.push('HSNCode');
        if (!formData.taxRate) missingFields.push('TaxRate');
        if (!formData.itc) missingFields.push('ITC');
        if (!formData.prodCode) missingFields.push('ProdCode');
        if (!formData.minQty) missingFields.push('MinQty');
        if (!formData.Main_Grp) missingFields.push('Main_Grp');
        if (!formData.Sub_Grp) missingFields.push('Sub_Grp');

        if (missingFields.length > 0) {
            alert('The following fields are required: ' + missingFields.join(', '));
            return;
        }

        const form = new FormData();

        // Update form.append with the new keys
        form.append('itemDesc', formData.itemDesc);
        form.append('hsnCode', formData.hsnCode);
        form.append('taxRate', formData.taxRate);
        form.append('closeFlag', formData.closeFlag);
        form.append('itc', formData.itc);
        form.append('itemUOM', formData.itemUOM);
        form.append('itemLocation', formData.itemLocation);
        form.append('origin', formData.origin);
        form.append('cth', formData.cth);
        form.append('minQty', formData.minQty);
        form.append('Main_Grp', formData.Main_Grp);
        form.append('Main_Grp_Desc', formData.Main_Grp_Desc);
        form.append('grade', formData.grade);
        form.append('validity', formData.validity);
        form.append('maxQty', formData.maxQty);
        form.append('Sub_Grp', formData.Sub_Grp);
        form.append('Sub_Grp_Desc', formData.Sub_Grp_Desc);
        form.append('abc', formData.abc);
        form.append('ved', formData.ved);
        form.append('reOrderQty', formData.reOrderQty);
        form.append('make', formData.make);
        form.append('prodCode', formData.prodCode);
        form.append('department', formData.department);
        form.append('department1', formData.department1);
        form.append('blockUnblock', formData.blockUnblock);
        form.append('accountCode', formData.accountCode);
        form.append('accountCodee', formData.accountCodee);

        // Append image if it exists
        if (formData.image) {
            form.append('image', formData.image);
        }

        try {
            if (isEditing) {
                await axios.put(`https://erpapi.emedha.in/pages/api/api/itemsss-mstt/${editId}`, form);
                setItems(items.map(item => (item.itemCd === editId ? { ...formData, itemCd: editId } : item)));
                alert('Item updated successfully!');
            } else {
                const response = await axios.post('https://erpapi.emedha.in/pages/api/api/itemsss-mst', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setItems([...items, { ...formData, id: response.data.itemId }]);
                alert('Item added successfully!');
                window.location.reload();
            }
        } catch (error) {
            alert('Item added successfully!');
            console.error('Error saving item:', error);
        }
    };

    const [dropdownVisible1, setDropdownVisible1] = useState(false)

    const handleEditItem = (item) => {
        setSearchTerm(item.itemCd);
        setFormData({ itemDesc: item.itemDesc, hsnCode: item.hsnCode, taxRate: item.taxRate, closeFlag: item.closeFlag, itc: item.itc, image: item.image, itemUOM: item.itemUOM, itemLocation: item.itemLocation, origin: item.origin, cth: item.cth, minQty: item.minQty, Main_Grp: item.Main_Grp, Main_Grp_Desc: item.Main_Grp_Desc, grade: item.grade, validity: item.validity, maxQty: item.maxQty, Sub_Grp: item.Sub_Grp, Sub_Grp_Desc: item.Sub_Grp_Desc, abc: item.abc, ved: item.ved, reOrderQty: item.reOrderQty, make: item.make, prodCode: item.prodCode, department: item.department, department1: item.department1, blockUnblock: item.blockUnblock, accountCode: item.accountCode, accountCodee: item.accountCodee });
        setEditId(item.itemCd);
        setIsEditing(true);
        setShowForm(true);
        setDropdownVisible1(false);
        setShowSearchh(false);
    };


    const handleSelectChange = (selectedOption) => {
        if (selectedOption) {
            setFormData({
                ...formData,
                itemCd: selectedOption.value, // Save itemCd (or the selected value)
                itemDesc: selectedOption.label, // Save itemDesc (or the selected label)
            });
        }
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setDropdownVisible1(true);
    };

    const handleSelectItem = (item) => {
        setSelectedItem(item); // Store the selected item
        setSearchTerm(item.itemCd); // Optionally, set the search term to the selected item code
        setDropdownVisible1(false); // Close the dropdown after selection
    };


    const [showSearch, setShowSearch] = useState(false);
    const [showSearchh, setShowSearchh] = useState(false);
    const handleBack = () => {
        navigate(-1);
    };
    const latestItem = items.reduce((max, item) => (item.itemCd > max.itemCd ? item : max), { itemCd: 0 });

    const toggleForm = () => {
        setShowForm(prevState => !prevState);
        setFormData({ itemCd: '', itemDesc: '', hsnCode: '', taxRate: '', closeFlag: '', itc: '', image: '', itemUOM: '', itemLocation: '', origin: '', cth: '', minQty: '', Main_Grp: '', Main_Grp_Desc: '', grade: '', validity: '', maxQty: '', Sub_Grp: '', Sub_Grp_Desc: '', abc: '', ved: '', reOrderQty: '', make: '', prodCode: '', department: '', department1: '', blockUnblock: '', accountCode: '', accountCodee: '' });
        setIsEditing(false);
        setEditId(null);
        setShowForm(true);
        setShowSearch(false);
        setShowSearchh(true);

    };

    const handleRefresh = () => {
        setFormData({
            itemCd: '', itemDesc: '', hsnCode: '', taxRate: '', closeFlag: '', itc: '', image: '', itemUOM: '', itemLocation: '', origin: '', cth: '', minQty: '', Main_Grp: '', Main_Grp_Desc: '', grade: '', validity: '', maxQty: '', Sub_Grp: '', Sub_Grp_Desc: '', abc: '', ved: '', reOrderQty: '', make: '', prodCode: '', department: '', department1: '', blockUnblock: '', accountCode: '', accountCodee: ''
        });
        setSelectedItem({
            itemCd: '', itemDesc: '', hsnCode: '', taxRate: '', closeFlag: '', itc: '', image: '', itemUOM: '', itemLocation: '', origin: '', cth: '', minQty: '', Main_Grp: '', Main_Grp_Desc: '', grade: '', validity: '', maxQty: '', Sub_Grp: '', Sub_Grp_Desc: '', abc: '', ved: '', reOrderQty: '', make: '', prodCode: '', department: '', department1: '', blockUnblock: '', accountCode: '', accountCodee: ''
        });
    };

    const handleViewItem = (item) => {
        setFormMode('view');
        setSelectedItem(item);
        setShowForm(true);
        setDropdownVisible1(false);
        setShowSearchh(false);
        setShowSearch(true);
    };

    const handleApprove = (id) => {
        if (id) {
            axios
                .put(`https://erpapi.emedha.in/pages/api/api/itemsss-mst/approve/${id}`)
                .then((response) => {
                    console.log('Item approved successfully:', response.data);
                    setItems((prevItems) =>
                        prevItems.map((item) =>
                            item.itemCd === id ? { ...item, isApproved: true } : item
                        )
                    );
                    alert('Item approved successfully');
                })
                .catch((error) => {
                    console.error('Error approving item:', error);
                    alert(error.response?.data?.message || 'Failed to approve item');
                });

        } else {
            alert("Item ID is invalid.");
        }
    };


    const handlePrint = () => {
        const printContent = document.getElementById("print-content");
        if (printContent) {
            const originalContent = document.body.innerHTML;
            document.body.innerHTML = printContent.innerHTML;
            window.print();
            document.body.innerHTML = originalContent;
        } else {
            alert("Printer content not found!");
        }
    };

    const handleInputChangee = (e) => {
        let value = e.target.value;
        if (/^\d{0,5}$/.test(value)) {
            setFormData({
                ...formData,
                taxRate: value
            });
        }
    };
    const handleInputChangge = (e) => {
        let value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setFormData({
                ...formData,
                hsnCode: value
            });
        }
    };
    const handleInputChanggee = (e) => {
        let value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setFormData({
                ...formData,
                minQty: value
            });
        }
    };
    const handleInputChanggeee = (e) => {
        let value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setFormData({
                ...formData,
                maxQty: value
            });
        }
    };
    const handleInputChangggeee = (e) => {
        let value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setFormData({
                ...formData,
                reOrderQty: value
            });
        }
    };
    const handleInputChangggaeee = (e) => {
        let value = e.target.value;
        if (/^\d{0,6}$/.test(value)) {
            setFormData({
                ...formData,
                accountCode: value
            });
        }
    };

    const handleMakeInputChange = (e) => {
        const { value } = e.target;
        if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 20) {
            setFormData({
                ...formData,
                make: value
            });
        }
    };
    const handleProdCodeInputChange = (e) => {
        const { value } = e.target;
        if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 25) {
            setFormData({
                ...formData,
                prodCode: value
            });
        }
    };
    const handleProdItemLocationInputChange = (e) => {
        const { value } = e.target;
        if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 50) {
            setFormData({
                ...formData,
                itemLocation: value
            });
        }
    };
    const handleProdItemDescInputChange = (e) => {
        const { value } = e.target;
        // if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 30) {
        setFormData({
            ...formData,
            itemDesc: value
        });
        // }
    };
    const handleProdCthInputChange = (e) => {
        const { value } = e.target;
        if (/^[a-zA-Z\s]{0,10}$/.test(value)) {
            setFormData({
                ...formData,
                cth: value
            });
        }
    };



    const [formMode, setFormMode] = useState('');

    // const userPermissions = user ? {
    //     add: user.add_permission,
    //     edit: user.edit_permission,
    //     view: user.view_permission,
    //     save: user.save_permission,
    //     approve: user.approve_permission,
    //     print: user.print_permission,
    //     close: user.close_permission,
    //     clear: user.clear_screen_permission
    // } : {};

    const userPermissions = user && user.permissions && user.permissions[1000]
        ? {
            add: user.permissions[1000].sub_ids[1001]?.permissions.add_permission || 0,
            edit: user.permissions[1000].sub_ids[1001]?.permissions.edit_permission || 0,
            view: user.permissions[1000].sub_ids[1001]?.permissions.view_permission || 0,
            save: user.permissions[1000].sub_ids[1001]?.permissions.save_permission || 0,
            approve: user.permissions[1000].sub_ids[1001]?.permissions.approve_permission || 0,
            print: user.permissions[1000].sub_ids[1001]?.permissions.print_permission || 0,
            close: user.permissions[1000].sub_ids[1001]?.permissions.exit_permission || 0,
            clear: user.permissions[1000].sub_ids[1001]?.permissions.refresh_permission || 0
        }
        : {};

    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };


    // icons css 

    const iconBox = (enabled) => ({
  width: "48px",
  height: "48px",
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: enabled ? "linear-gradient(135deg, #ffffff, #f1f5ff)" : "#f0f0f0",
  boxShadow: enabled
    ? "0 4px 10px rgba(0,0,0,0.08)"
    : "none",
  cursor: enabled ? "pointer" : "not-allowed",
  opacity: enabled ? 1 : 0.5,
  transition: "all 0.3s ease",
});

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px 24px",
  borderRadius: "14px",
  background: "linear-gradient(135deg, #e0e7ff, #f8fafc)",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
};

const titleStyle = {
  color: "#1e3a8a",
  fontSize: "2rem",
  fontWeight: "700",
  letterSpacing: "1px",
};

const iconContainer = {
  display: "flex",
  gap: "14px",
  alignItems: "center",
};


    return (
        <>
            <div style={{ backgroundColor: "#ffffff", padding: "1rem", margin: "0 auto", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", border: '1px solid black', borderRadius: '10px' }} >
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <img src={A1} alt="item" style={{ width: "20%" }} />
                    <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>
                        ITEM MASTER
                    </h1>
                    <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.add && userPermissions.add !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.add && userPermissions.add !== 0 && getButtonState('create') ? 1 : 0.5
                        }}>
                            <FaPlus size={30} onClick={() => {
                                if (userPermissions.add && userPermissions.add !== 0) { toggleForm(); setShowSearch(false); setFormMode('create'); }
                            }} />
                        </div>

                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.edit && userPermissions.edit !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit') ? 1 : 0.5
                        }}>
                            <MdEdit size={30} onClick={() => {
                                if (userPermissions.edit && userPermissions.edit !== 0) { setShowForm(true); setFormMode('edit'); setShowSearch(true); setShowSearchh(false); }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.view && userPermissions.view !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.view && userPermissions.view !== 0 && getButtonState('view') ? 1 : 0.5
                        }}>
                            <LuView size={30} onClick={userPermissions.view && userPermissions.view !== 0 ? handleViewItem : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? "pointer" : "not-allowed",
                            opacity: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? 1 : 0.5
                        }}>
                            <HiOutlineRefresh size={30} onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? "pointer" : "not-allowed",
                            opacity: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? 1 : 0.5
                        }}>
                            <FaSave size={30} onClick={userPermissions.save && userPermissions.save !== 0 ? handleSaveItem : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? "pointer" : "not-allowed",
                            opacity: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? 1 : 0.5
                        }}>
                            <FaCheck size={30}
                             //onClick={userPermissions.approve && userPermissions.approve !== 0 ? () => handleApprove(selectedItem.itemCd) : null} 
                             />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? "pointer" : "not-allowed",
                            opacity: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? 1 : 0.5
                        }}>
                            <IoPrint size={30} onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                            opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                        }}>
                            <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                        </div>
                    </div>
                </div> */}

                <div style={headerStyle}>
  {/* Left Logo */}
  <img src={A1} alt="item" style={{ width: "270px", borderRadius: "10px" }} />

  {/* Title */}
  <h1 style={titleStyle}>ITEM MASTER</h1>

  {/* Actions */}
  <div style={iconContainer}>
    
    {/* Add */}
    <div style={iconBox(userPermissions.add && userPermissions.add !== 0 && getButtonState('create'))}>
      <FaPlus size={20} color="#2563eb"
        onClick={() => {
          if (userPermissions.add && userPermissions.add !== 0) {
            toggleForm();
            setShowSearch(false);
            setFormMode('create');
          }
        }}
      />
    </div>

    {/* Edit */}
    <div style={iconBox(userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit'))}>
      <MdEdit size={20} color="#f59e0b"
        onClick={() => {
          if (userPermissions.edit && userPermissions.edit !== 0) {
            setShowForm(true);
            setFormMode('edit');
            setShowSearch(true);
            setShowSearchh(false);
          }
        }}
      />
    </div>

    {/* View */}
    <div style={iconBox(userPermissions.view && userPermissions.view !== 0 && getButtonState('view'))}>
      <LuView size={20} color="#10b981"
        onClick={userPermissions.view && userPermissions.view !== 0 ? handleViewItem : null}
      />
    </div>

    {/* Refresh */}
    <div style={iconBox(userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear'))}>
      <HiOutlineRefresh size={20} color="#6366f1"
        onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null}
      />
    </div>

    {/* Save */}
    <div style={iconBox(userPermissions.save && userPermissions.save !== 0 && getButtonState('save'))}>
      <FaSave size={20} color="#22c55e"
        onClick={userPermissions.save && userPermissions.save !== 0 ? handleSaveItem : null}
      />
    </div>

    {/* Approve */}
    <div style={iconBox(userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve'))}>
      <FaCheck size={20} color="#16a34a" />
    </div>

    {/* Print */}
    <div style={iconBox(userPermissions.print && userPermissions.print !== 0 && getButtonState('print'))}>
      <IoPrint size={20} color="#0ea5e9"
        onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null}
      />
    </div>

    {/* Close */}
    <div style={iconBox(userPermissions.close && userPermissions.close !== 0 && getButtonState('close'))}>
      <RiCloseLargeFill size={20} color="#ef4444"
        onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
      />
    </div>

  </div>
</div>
                <p>Welcome To Item Master: {userName}</p>
                <hr />

                                {!showForm && (
                    <div
                        style={{
                            marginTop: "20px",
                            border: "2px dashed #cbd5e1",
                            borderRadius: "16px",
                            height: "320px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                            boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <div style={{ textAlign: "center", color: "#64748b" }}>

                            {/* Icon */}
                            <div
                                style={{
                                    fontSize: "48px",
                                    marginBottom: "10px",
                                    opacity: 0.6,
                                }}
                            >
                                📦
                            </div>

                            {/* Text */}
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#475569",
                                }}
                            >
                                Select an action from the header to begin
                            </h2>
                        </div>
                    </div>
                )}
                {showForm && (
                    <>
                        <div className="container" >
                            {showSearch && (

                                <div className="mb-3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '30%', position: 'relative', paddingLeft: '46px' }}>
                                    <label style={{ marginRight: '22px', color: 'darkblue', fontWeight: 'bold' }}>
                                        <FaSearch />
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Search by Item CD or Description"
                                        value={searchTerm}
                                        onChange={(e) => { setSearchTerm(e.target.value); setDropdownVisible1(true); }}
                                        style={{ width: '100%', border: '1px solid #e2e8f0', padding: '0.25rem' }}
                                    />
                                    {filteredItems.length > 0 && dropdownVisible1 && (
                                        <ul
                                            style={{
                                                maxHeight: '150px',
                                                overflowY: 'auto',
                                                border: '1px solid #e2e8f0',
                                                width: '80%',
                                                position: 'absolute',
                                                backgroundColor: '#fff',
                                                zIndex: 1,
                                                marginTop: '5px',
                                                padding: 0,
                                                top: '100%',
                                                left: '80px',
                                            }}
                                        >
                                            {filteredItems
                                                .filter(item =>
                                                    String(item.itemCd).toLowerCase().includes(searchTerm.toLowerCase()) ||
                                                    String(item.itemDesc).toLowerCase().includes(searchTerm.toLowerCase())
                                                )
                                                .map((item) => (
                                                    <li
                                                        key={item.id}
                                                        onClick={() => handleEditItem(item)}
                                                        style={{
                                                            padding: '0.5rem',
                                                            cursor: 'pointer',
                                                            listStyleType: 'none',
                                                            borderBottom: '1px solid #e2e8f0',
                                                        }}
                                                    >
                                                        {item.itemCd} - {item.itemDesc}
                                                    </li>
                                                ))}
                                        </ul>
                                    )}
                                </div>


                            )}

                            {showSearchh && (
                                <div className="mb-3" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '30%', position: 'relative', paddingLeft: '6px' }}>
                                    <label className="me-4 mb-0" style={{ color: "darkblue", fontWeight: 'bold' }}>ItemCd</label>
                                    <input type="text" placeholder="Item CD" value={latestItem ? latestItem.itemCd : ''}  autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} />
                                </div>
                            )}

                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '60%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>ItemDesc</label>
                                    <input type="text" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" name="itemDesc" value={formData.itemDesc || ''} onChange={handleProdItemDescInputChange} maxLength={30} readOnly={formMode === 'view'} />
                                </div>
                                <div style={{ width: '20%' }}>
                                    <button style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem", backgroundColor: "#edf2f7" }}>
                                        Barcode Print
                                    </button>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '15%' }}>
                                    {formMode === 'view' ? (
                                        <img src={formData.image || ''} alt="item" style={{ width: "80px", height: "80px", objectFit: "contain", marginTop: "10px" }} />
                                    ) : (
                                        <input type="file" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" name="image" onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })} readOnly={formMode === 'view'} />
                                    )}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '15%' }}>
                                    {formMode === 'edit' ? (
                                        <img src={formData.image || ''} alt="item" style={{ width: "80px", height: "80px", objectFit: "contain", marginTop: "10px" }} />
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>

                            <div className="mt-3" style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '35%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>HSNCode</label>
                                    <input type="number" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" name="hsnCode" value={formData.hsnCode || ''} onChange={handleInputChangge} readOnly={formMode === 'view'} />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '20%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>TaxRate</label>
                                    <input type="number" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" name="taxRate" value={formData.taxRate || ''} onChange={handleInputChangee} readOnly={formMode === 'view'} />
                                    <span style={{ position: 'absolute', right: '45%', transform: 'translateY(-50%)', color: 'darkblue', marginTop: '20px' }}>%</span>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '10%', paddingLeft: '200px' }}>
                                    <input type="checkbox" style={{ width: "30px", height: "15px", border: "1px solid #e2e8f0", padding: "0.25rem", backgroundColor: "#edf2f7" }} name="closeFlag" value={formData.closeFlag || ''} onChange={handleInputChange}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" readOnly={formMode === 'view'} />
                                    <label style={{ color: "darkblue", fontWeight: 'bold', marginLeft: '0.5rem' }}>CloseFlag</label>
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '30%', paddingLeft: '16px' }}>
                                <label className="me-5" style={{ color: "darkblue", fontWeight: 'bold' }}>ITC</label>
                                <select style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="itc" value={formData.itc} onChange={handleInputChange} readOnly={formMode === 'view'}>
                                <option value="select ITC"></option>
                                    <option value="N">N</option>
                                    <option value="Y">Y</option>
                                </select>
                            </div>
                        </div>
                        <div className="mt-2 mb-1 me-5" style={{ marginBottom: "1rem" }}>
                            <label style={{ display: "block", color: "darkblue", fontWeight: 'bold', }}>ITEM CHARACTERSTICS</label>
                        </div>
                        <div style={{ border: "1px solid #e2e8f0", padding: "1rem" }}>
                            <div className="mt-0" style={{ display: 'flex', alignItems: 'center', gap: '1rem', width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '31%' }}>
                                    <label className="me-4" style={{ color: "darkblue", fontWeight: 'bold' }}>ITEMUOM</label>
                                    <select style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="itemUOM" value={formData.itemUOM} onChange={handleInputChange} required readOnly={formMode === 'view'}>
                                        <option value="Select">Select</option>
                                        <option value="KG">KG</option>
                                        <option value="TON">TON</option>
                                        <option value="LTRS">LTRS</option>
                                        <option value="PCS">PCS</option>
                                        <option value="NOS">NOS</option>
                                    </select>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '62%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>ItemLocation</label>
                                    <input type="text" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="itemLocation" value={formData.itemLocation}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" onChange={handleProdItemLocationInputChange} readOnly={formMode === 'view'} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '24%' }}>
                                    <label className="me-4" style={{ color: "darkblue", fontWeight: 'bold' }}>ORGIN</label>
                                    <select style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="origin" value={formData.origin} onChange={handleInputChange} readOnly={formMode === 'view'}>
                                        <option value="Select">Select</option>
                                        <option>Local</option>
                                        <option>international</option>
                                    </select>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '25%' }}>
                                    <label className="me-4" style={{ color: "darkblue", fontWeight: 'bold' }}>CTH</label>
                                    <input type="text" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="cth" value={formData.cth}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" onChange={handleProdCthInputChange} readOnly={formMode === 'view'} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '26%' }}>
                                    <label className="me-5" style={{ color: "darkblue", fontWeight: 'bold' }}>MinQty</label>
                                    <input type="number" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="minQty" value={formData.minQty}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" onChange={handleInputChanggee} readOnly={formMode === 'view'} />
                                </div>
                            </div>

                            <div className="mt-3" style={{ display: 'flex', alignItems: 'center', gap: '1rem', width: '100%' }}>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '31%', paddingLeft: '9px' }}>
                                    <label className="me-5" style={{ color: "darkblue", fontWeight: 'bold' }}>MAKE</label>
                                    <input type="text" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="make" value={formData.make}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" onChange={handleMakeInputChange} maxLength={20} readOnly={formMode === 'view'} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '60%', paddingLeft: '21px' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>ProdCode</label>
                                    <input type="text" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="prodCode" value={formData.prodCode}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" onChange={handleProdCodeInputChange} readOnly={formMode === 'view'} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '24%' }}>
                                    <label className="me-4" style={{ color: "darkblue", fontWeight: 'bold' }}>GRADE</label>
                                    <select style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="grade" value={formData.grade} onChange={handleInputChange} required readOnly={formMode === 'view'}>
                                        <option value="Select">Select</option>
                                        <option> A</option>
                                        <option> B</option>
                                        <option> C</option>
                                        <option> D</option>
                                    </select>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '25%' }}>
                                    <label style={{ color: "darkblue", fontWeight: 'bold' }}>Validity</label>
                                    <select style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="validity" value={formData.validity} onChange={handleInputChange} readOnly={formMode === 'view'}>
                                        <option value="Select">Select</option>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '26%' }}>
                                    <label className="me-5" style={{ color: "darkblue", fontWeight: 'bold' }}>MaxQty</label>
                                    <input type="number" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="maxQty" value={formData.maxQty}   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" onChange={handleInputChanggeee} readOnly={formMode === 'view'} />
                                </div>
                            </div>

                            <div className="mt-3" style={{ display: 'flex', alignItems: 'center', gap: '1rem', width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '31%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>MainGroup</label>

                                    {/* <Select
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%', // Ensures full width
                                                maxWidth: '100%', // Prevents any expansion beyond container width
                                                border: '1px solid #e2e8f0',
                                                padding: '0.25rem',
                                                whiteSpace: 'nowrap', // Prevents text from wrapping
                                                overflow: 'hidden',  // Hides any overflowing text
                                                textOverflow: 'ellipsis', // Adds '...' if the text is too long
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '0.715rem', // Optional: smaller font size for placeholder
                                            }),
                                        }}
                                        isDisabled={formMode === 'view'}
                                        name="Main_Grp"
                                        value={optionss.find(option => option.Main_Grp === formData.Main_Grp)}
                                        onChange={handleSelectChangemg} // Handle change
                                        options={optionss}
                                        placeholder="Select Main Group" // Placeholder text
                                        menuPortalTarget={document.body}
                                        menuPlacement="bottom"
                                    /> */}
                                    <Select
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%', // Ensures full width
                                                maxWidth: '100%', // Prevents any expansion beyond container width
                                                border: '1px solid #e2e8f0',
                                                padding: '0.25rem',
                                                whiteSpace: 'nowrap', // Prevents text from wrapping
                                                overflow: 'hidden', // Hides any overflowing text
                                                textOverflow: 'ellipsis', // Adds '...' if the text is too long
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '0.715rem', // Optional: smaller font size for placeholder
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                overflowY: 'auto', // Adds vertical scrolling if the dropdown has too many options
                                            }),
                                        }}
                                        isDisabled={formMode === 'view'}
                                        name="Main_Grp"
                                        value={optionss.find(option => option.Main_Grp === formData.Main_Grp)}
                                        onChange={handleSelectChangemg} // Handle change
                                        options={optionss}
                                        placeholder="Select Main Group" // Placeholder text
                                        menuPortalTarget={document.body} // Ensures the dropdown renders outside the parent container to avoid clipping
                                        menuPlacement="auto" // Automatically places the menu above or below based on available space
                                    />

                                </div>

                                <input type="text" style={{ width: "60%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="Main_Grp_Desc"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={selectedDescription} onChange={handleInputChange} readOnly={formMode === 'view'} />

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '24%' }}>
                                    <label className="me-5" style={{ color: "darkblue", fontWeight: 'bold' }}>ABC</label>
                                    <select style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="abc" value={formData.abc} onChange={handleInputChange} readOnly={formMode === 'view'}>
                                        <option value="Select">Select</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                    </select>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '25%' }}>
                                    <label className="me-4" style={{ color: "darkblue", fontWeight: 'bold' }}>VED</label>
                                    <select style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="ved" value={formData.ved} onChange={handleInputChange} readOnly={formMode === 'view'}>
                                        <option value="Select">Select</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                    </select>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '25%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>ReOrderQty</label>
                                    <input type="number" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="reOrderQty"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={formData.reOrderQty} onChange={handleInputChangggeee} readOnly={formMode === 'view'} />
                                </div>
                            </div>
                            <div className="mt-3 mb-1" style={{ display: 'flex', alignItems: 'center', gap: '1rem', width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '33%' }}>
                                    <label className="me-4" style={{ color: "darkblue", fontWeight: 'bold' }}>SubGroup</label>



                                    {/* <Select
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                border: '1px solid #e2e8f0',
                                                padding: '0.25rem',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '0.775rem', // Smaller font size
                                            }),
                                        }}
                                        isDisabled={formMode === 'view'}
                                        name="Sub_Grp"
                                        // Ensuring we use the correct value object from filteredSubGroups
                                       // value={filteredSubGroups.find(option => option.Sub_Grp === formData.Sub_Grp)}
                                       value={selectedOption ? { value: selectedOption.Sub_Grp, label: `${selectedOption.Sub_Grp} - ${selectedOption.Sub_Grp_Desc.trim()}` } : null}
                                       onChange={handleSelectChangee} // Update formData with selected value
                                        options={filteredSubGroups.map(group => ({
                                            value: group.Sub_Grp,
                                            label: `${group.Sub_Grp} - ${group.Sub_Grp_Desc.trim()}`, // Trim any unwanted whitespace
                                        }))}
                                        placeholder="Select Sub Group"
                                        menuPortalTarget={document.body} 
                                          menuPlacement="bottom"
                                        
                                    /> */}
                                    <Select
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%', // Ensures full width
                                                border: '1px solid #e2e8f0',
                                                padding: '0.25rem',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '0.775rem', // Smaller font size for the placeholder
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                overflowY: 'auto', // Allows scrolling in the menu if it's too long
                                            }),
                                        }}
                                        isDisabled={formMode === 'view'}
                                        name="Sub_Grp"
                                        value={selectedOption ? { value: selectedOption.Sub_Grp, label: `${selectedOption.Sub_Grp} - ${selectedOption.Sub_Grp_Desc.trim()}` } : null}
                                        onChange={handleSelectChangee} // Update formData with selected value
                                        options={filteredSubGroups.map(group => ({
                                            value: group.Sub_Grp,
                                            label: `${group.Sub_Grp} - ${group.Sub_Grp_Desc.trim()}`, // Trim any unwanted whitespace
                                        }))}
                                        placeholder="Select Sub Group"
                                        menuPortalTarget={document.body} // Render the dropdown outside the form container to avoid clipping
                                        menuPlacement="auto" // Automatically chooses top or bottom based on available space
                                    />



                                </div>

                                <input type="text" style={{ width: "64%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="Sub_Grp_Desc"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={selectedSubDescription} onChange={handleInputChange} readOnly={formMode === 'view'} />

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '30%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>Department</label>
                                    <input type="text" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="department"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={formData.department} onChange={handleInputChange} readOnly={formMode === 'view'} />
                                </div>
                                <input type="text" style={{ width: "50%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="department1"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={formData.department1} onChange={handleInputChange} readOnly={formMode === 'view'} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <div style={{ flexGrow: 1, borderTop: '1px solid black', marginRight: '10px', }}></div>
                                <span style={{ padding: '0 10px', fontSize: '25px' }}>Accounts</span>
                                <div style={{ flexGrow: 1, borderTop: '1px solid black', marginLeft: '10px', }}></div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '30%' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>Block / Unblock</label>
                                    <input type="text" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="blockUnblock"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={formData.blockUnblock || ''} onChange={handleInputChange} readOnly={formMode === 'view'} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '60%', paddingLeft: '500px' }}>
                                    <label className="me-3" style={{ color: "darkblue", fontWeight: 'bold' }}>A/c Code</label>
                                    <input type="number" style={{ width: "100%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="accountCode"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={formData.accountCode} onChange={handleInputChangggaeee} readOnly={formMode === 'view'} />
                                </div>
                                <input type="text" style={{ width: "40%", border: "1px solid #e2e8f0", padding: "0.25rem" }} name="accountCodee"   autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" value={formData.accountCodee} onChange={handleInputChange} readOnly={formMode === 'view'} />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default ItemMaster;

